
import {ComputedRef, defineComponent, onUnmounted, watch} from "vue";
import Modal from "./Modal.vue";
import { useStore } from "vuex";
import { wrapLoading } from "../../utils/wrap_loading";
import { dispatchError } from "../../utils/error_handling";
import { Notification } from "../../../../domain/entities/notifications/notification";
import { disableBodyOverflow, enableBodyOverflow } from "../mixins";
import { computed } from "@vue/reactivity";

export default defineComponent({
  name: "NotificationModal",
  components: { Modal },
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    notificationID: {
      type: Number,
      required: false
    }
  },
  setup(props) {
    const store = useStore();

    const notification: ComputedRef<Notification> = computed(() => {
      return store.getters["notification_module/notification"];
    });

    const get = async (id: number) => {
      try {
        await wrapLoading(async () => {
          await store.dispatch("notification_module/get", id);
        });
      } catch (e) {
        await dispatchError(e);
      }
    };

    watch(
        () => props.isOpen,
        (value) => {
          if (value && props.notificationID != null) {
            get(props.notificationID);
          }
        },
        { immediate: true }
    );

    onUnmounted(() => {
      enableBodyOverflow();
    });

    return { notification };
  }
});
